import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import { Description } from '../../../shared/vulns/Drawer';
import type { VulnIssue } from '../../../../../shared/issuesV2';

/**
 * VulnerabilityIssueDetailsDescription displays the description of the vulnerability
 * currently being viewed.
 */
const VulnerabilityIssueDetailsDescription: VoidFunctionComponent = () => {
  const activeIssue = useSelector(IssuesV2Store.selectors.getIssueDetails) as VulnIssue;

  if (!activeIssue) {
    return null;
  }

  return (
    <Description
      description={activeIssue.details || ''}
    />
  );
};

export default VulnerabilityIssueDetailsDescription;
